import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    step: 0,
    booking: { excessCharges: [], deactiveCar: false, confirm: false,deliveryBy: "", pickupBy :"", refundHold: {}, refund: {}, excessBalance: [], customerId: "", firstName: "", excess: {}, lastName: "", phone: { code: "+91", priority: 1, type: "normal" }, phone2: { code: "+91", priority: 2, type: "normal" }, customer: {}, phone3: { code: "+91", priority: 3, type: "normal" }, deliveryDetails: {}, pickupDetails: {}, totalDays: 0, point: 0, advance: {}, balance: [] }
};

const bookingSlice = createSlice({
    name: "booking",
    initialState,
    reducers: {
        setStep: (state, { payload }) => {
            state.step = payload
        },
        setBooking: (state, { payload }) => {
            state.booking = { ...state?.booking, ...payload }
        },
        setDelivery: (state, { payload }) => {
            state.booking.deliveryDetails = { ...state.booking.deliveryDetails, ...payload }
        },
        setPickup: (state, { payload }) => {
            state.booking.pickupDetails = { ...state.booking.pickupDetails, ...payload }
        },
        setAdvance: (state, { payload }) => {
            state.booking.advance = { ...state.booking.advance, ...payload }
        },
        setExcess: (state, { payload }) => {
            state.booking.excess = { ...state.booking.excess, ...payload }
        },
        setPhone: (state, { payload }) => {
            state.booking.phone = { ...state.booking.phone, ...payload }
        },
        setPhone2: (state, { payload }) => {
            state.booking.phone2 = { ...state.booking.phone2, ...payload }
        },
        setPhone3: (state, { payload }) => {
            state.booking.phone3 = { ...state.booking.phone3, ...payload }
        },
        setCustomerPhoto: (state, { payload }) => {
            state.booking.customer = { ...state.booking.customer, ...payload }
        },
        setRefundHold: (state, { payload }) => {
            state.booking.refundHold = { ...state.booking.refundHold, ...payload }
        },
        setRefund: (state, { payload }) => {
            state.booking.refund = { ...state.booking.refund, ...payload }
        },
        setConfirm: (state, { payload }) => {
            state.booking.confirm = payload
        },
        setDeactive: (state, { payload }) => {
            state.booking.deactiveCar = payload
        },
        clearValue: () => initialState,
    }
});

export const { setStep, clearValue,setDeactive,  setBooking,setConfirm,  setDelivery, setPickup, setPhone, setAdvance, setPhone2, setPhone3, setCustomerPhoto, setExcess, setRefund, setRefundHold } = bookingSlice.actions
export default bookingSlice.reducer;
